import 'semantic-ui-css/semantic.min.css'
import { React , Suspense, useEffect, useState }  from 'react';
import {
  useLoaderData, useNavigate , Link
} from "react-router-dom";
//import data from './' + process.env.PUBLIC_URL + '/data/epublicaties.json'
import Loading from './Loading';
import ApplicationHeader from './Header';
import ApplicationFooter from './Footer';
import { Container , Header, Segment ,  Icon , Popup , Button , Grid , Image , Label,  Divider , Message, Table, TextArea , Form } from 'semantic-ui-react';
import parse from 'html-react-parser'
import he from 'he'
import epubLogo from './assets/epub-logo.png'
//const pub = process.env.PUBLIC_URL

import './translations/i18n';
import { useTranslation } from 'react-i18next';

import "/node_modules/flag-icons/css/flag-icons.min.css";
import useWindowDimensions from './useWindowDimensions'
const pjson = require('../package.json')
const base = (!!pjson.homepage) ? pjson.homepage : '/'
const apiURL = (process.env.NODE_ENV === 'development') ? 'http://localhost/mediatheken/epub/data' : `https://lib.arteveldehogeschool.be/mediatheken/epub/data`
const languages = [
  { lang : 'nl' , label : 'Nederlands' , flag : 'be' , title  : 'Arteveldehogeschool Mediatheken - Epublicaties' },
  { lang : 'en' , label : 'English' , flag : 'gb' , title : 'Artevelde UAS Libraries - Epublications'}]


const tax = [
  'campus' ,
  'uitgavenvorm' ,
  'mediatheek' ,
  //'opleiding' ,
  'domein' ,
  'thema' ,
];

const icons = {
  E_BOOK : 'book',
  E_TIJDSCHRIFT : 'address book',
  WEBSITE : 'globe',
  E_DATABANK : 'computer',
  E_HANDBOEK : 'book',
  KRANT : 'newspaper',
  E_PLATFORM : 'keyboard',
  E_DOCUMENT : 'file',
  MULTIMEDIA : 'play'
}

const filterFields = [
  'mediatheek' , 'trefwoorden' , 'domein'
]

const  Detail = () => {
  const obj = useLoaderData();
  const data = obj.detail
  const [ user , setUser ] = useState(obj.user)
  const navigate = useNavigate()
  const { t , i18n } = useTranslation();
  const [ locale , setLocale ] = useState(localStorage.getItem('i18nextLng'))
  const [ showMore , setShowMore ] = useState({})
  const [ filterData , setFilterData] = useState({})
  const [ email , setEmail ] = useState(user !== null ? user.loginData_emailAddress : "")
  const [ emailValid , setEmailValid ] = useState(false)
  const [ requestingData , setRequestingData ] = useState(false)
  const [ reportingError , setReportingError ] = useState(false)
  const [ problemMessage , setProblemMessage ] = useState(!!sessionStorage.getItem('problemMessage') ? sessionStorage.getItem('problemMessage') : '')
  const probMinChar = 25
  const probMaxChar = 450
  i18n.on('languageChanged', (lng) => setLocale(lng))

  const [ loginData , setLoginData] = useState(null)

  const [ copied, setCopied ] = useState({
    gebruikersnaam : false ,
    wachtwoord : false
  })

  useEffect(() => {
    setTimeout(() => setCopied({
      gebruikersnaam : false ,
      wachtwoord : false
    }) , 4000)
  },[copied])

  useEffect(() => {
    setTimeout(() => { 
      console.log('Reset Timer & LoginData')
      setLoginData(null) 
    }, 60 * 1000)
  },[loginData])

  const maxFilters = 6

  useEffect(() => {
    document.title = data.titel
    filterFields.map((ff) => {
      setShowMore(obj => ({...obj , [ff] : false}))
    })
  },[])

  const handleChange = (e , {value }) => {
    setEmail(value)
  }

  useEffect(() => {
    let validEmail = validateEmail(email)
    setEmailValid(validEmail)
  },[email])

  const copyToClipBoard = (field,text) => {
    const f = field
    navigator.clipboard.writeText(text).then(
      () => {
        setCopied(obj => ({
          ...obj , 
          [f] : true
        }))
      },
      () => {
        console.error('Error klembord')
      },
    );
  }

  const handleTextarea =  ( e , { name , value } ) => { 
    setProblemMessage(value)
    sessionStorage.setItem('problemMessage',value)
  }

  const sendAccessCode = () => {
    setRequestingData(true)
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'))
    var raw = JSON.stringify({
      "email": email ,
      "locale" : locale
    });

    console.log(myHeaders)
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(`${apiURL}/sendAccessCode/${data.id}/`, requestOptions)
      .then(response => response.json())
      .then(result => { 
        console.log(result);
        
        if(!!result.success) {
          alert(t(`aanvraag_geslaagd`))
          setRequestingData(false)
        } else {
          alert("Fout: " + t(result.error))
          setRequestingData(false)
        }
        setTimeout(() => {
          setRequestingData(false)
        }, 10000)
      })
      .catch(error => console.log('error', error));
  } 

  const userActivatie = ( onderwijsmethode ) => {
    console.log(onderwijsmethode)
  }

  const validateEmail = (email) => {
    return (String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ) && [ 'arteveldehs.be' , 'student.arteveldehs.be' ].some((val) => email.toLowerCase().split('@')[1] === val)) 
  };

  const getLoginData = () => {
    setLoginData(null)
    const myHeaders = new Headers()
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'))
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow" ,
    };
    let call = `${apiURL}/getLoginData/${data.id}/`

    fetch(call,requestOptions).then((data) => data.json()).then((login) => {
      if(!!!login.error) {
        setLoginData(login.data)
      } else {
        switch(login.error) {
          case 'NO_LOGIN' :
            setUser(null)
            alert(login.error)
            break
        }
      }
    })

  }

  const reportProblem = () => {
    setReportingError(true)
    if(user !== null && (new Date() < new Date(user.exp * 1000))) {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'))
      
      var raw = JSON.stringify({
        locale : locale ,
        message : problemMessage
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow" ,
        body : raw
      };
      
      let call = `${apiURL}/reportProblem/${data.id}/`
      fetch(call,requestOptions)
        .then(response => response.json())
        .then(result => {
          if(!!result.error && result.error === "FALSE_LOGIN") {
            loginAgain()
          } else if(!!result.error) {
            alert(result.error)
          } else {
            sessionStorage.removeItem('problemMessage')
            alert(t('problemReported' , { titel : data.titel }))
            setProblemMessage('')
          }
          setTimeout(() => {
            setReportingError(false)
          }, 4000)
        })
    } else {
      loginAgain()
      setTimeout(() => {
        setReportingError(false)
      }, 4000)
    }
    
  }

  const loginAgain = () => {
    localStorage.removeItem('token')
    alert(t('loginAgain'))
    navigate(0)
  }
  

  return (
    <Container fluid>
    <Container className="App">
      <ApplicationHeader user={user} />
      <Button onClick={() => navigate(base)}>Home</Button>
      <Suspense fallback={<Loading />}>
    {!!!data.error &&
        <Segment>
          <Grid stackable columns='equal' verticalAlign='middle'>
            <Grid.Row>
              <Grid.Column width={2}>
                {data.uitgelicht === '1'  &&
                    <Popup content={t(`uitgelicht`)} trigger={<Link to={base + 'uitgelicht/uitgelicht'}><Icon circular inverted name='hand point right outline' color='teal' alt={t(`uitgelicht`)} /></Link>} />
                }
                {data.uitgavenvorm.map(( k , v) => {
                  return <Popup content={t(`taxonomieItems.${k}`)} trigger={<Link to={base + 'uitgavenvorm/' + k}><Icon circular inverted name={icons[k]} color='blue' alt={t(`taxonomieItems.${k}`)} /></Link>} />
                })}
              </Grid.Column>
              <Grid.Column>
                <Header as='h1'>{data.titel}</Header>
              </Grid.Column>
              <Grid.Column width={4}>
                {!!data.image && 
                    <Image src={data.image} />
                }
                {!!!data.image && 
                    <Image src={epubLogo} />
                }
              </Grid.Column>
            </Grid.Row>
            <Divider />
            <Grid.Row>
              <Grid.Column width={3}>{t('fields.uitgavenvorm')}</Grid.Column>
              <Grid.Column>
                {data.uitgavenvorm.map((uv) => {
                  //return <Link to={base + 'uitgavenvorm/' +uv}>{uv}</Link>
                  return <Link to={base + 'uitgavenvorm/' +uv}><Label color='blue' as='a'><Icon name={icons[uv]} />{t(`taxonomieItems.${uv}`)}</Label></Link>
                })}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                  <Grid.Column width={3}>{t('fields.link')}</Grid.Column>
                  <Grid.Column>
                    <Segment>
                      <a href={data.link} target='_blank' rel='noopener noreferrer'>{data.link}</a>
                  </Segment></Grid.Column>
                </Grid.Row>
            {
              !!data.beschrijving && !!data.beschrijving[locale] && 
                <Grid.Row>
                  <Grid.Column width={3}>{t('fields.beschrijving')}</Grid.Column>
                  <Grid.Column>
                    <Segment>
                      {!!data.beschrijving[locale] && 
                        parse(he.decode(data.beschrijving[locale]))
                      }
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
            }
            {
              !!data.beschrijving && !!!data.beschrijving[locale] && 
                <Grid.Row>
                  <Grid.Column width={3}>{t('fields.beschrijving')}</Grid.Column>
                  <Grid.Column>
                    <Segment
                      color='red'
                    >
                      <i>{t('OTHERLANG', { lang : t(Object.keys(data.beschrijving)[0])})}</i>
                      <Divider />
                      {!!data.beschrijving[Object.keys(data.beschrijving)[0]] && 
                        parse(he.decode(data.beschrijving[Object.keys(data.beschrijving)[0]]))
                      }
                    </Segment>
                    
                    
                  </Grid.Column>
                </Grid.Row>
            }
            {data.trefwoorden.length > 0 && 
              <Grid.Row>
                <Grid.Column width={3}>
                  {t('fields.trefwoorden')}</Grid.Column>
                <Grid.Column>
                  {(data.trefwoorden.length <= maxFilters ? data.trefwoorden : showMore.trefwoorden ? data.trefwoorden : data.trefwoorden.slice(0,maxFilters)).map((t) => {
                    return <Label  style={{color : 'black'}}><Icon name="tag" /><Link to={base + 'trefwoorden/' + t}>{t.split('_')[0]}</Link></Label>
                  })}
                  {
                  (data.trefwoorden.length > maxFilters) &&
                      <a style={{cursor : 'pointer' , display : 'block'}} onClick={() => setShowMore(obj => ({...obj , trefwoorden : !showMore.trefwoorden}))}>{
                        showMore.trefwoorden ? t('showLess') :  t('showMore')
                      }</a>
                  }
                </Grid.Column>
              </Grid.Row>
            }
            {data.domein.length > 0 &&
              <Grid.Row>
                <Grid.Column width={3}>
                  {t('fields.domein')}
                </Grid.Column>
                <Grid.Column>
                  {(data.domein.length <= maxFilters ? data.domein : showMore.domein ? data.domein : data.domein.slice(0,maxFilters)).map((d) => {
                    return <Label style={{color : 'black'}}><Icon name="bullseye" /><Link to={base + 'domein/' + d}>{t(`taxonomieItems.${d}`)}</Link></Label>
                  })}
                  {
                  (data.domein.length > maxFilters) &&
                      <a style={{cursor : 'pointer' , display : 'block'}} onClick={() => setShowMore(obj => ({...obj , domein : !showMore.domein}))}>{
                        showMore.domein ? t('showLess') :  t('showMore')
                      }</a>
                  }
                </Grid.Column>
              </Grid.Row>
            }
            {
              !!data.opmerking && !!data.opmerking[locale]  && 
                <Grid.Row> <Grid.Column width={3}>{t('fields.opmerking')}</Grid.Column>
                  <Grid.Column>
                  <Segment>{!!data.opmerking[locale] &&
                    parse(he.decode(data.opmerking[locale]))
                  }</Segment></Grid.Column>
                </Grid.Row>
            }
            {
              !!data.opmerking && !!!data.opmerking[locale]  && 
                <Grid.Row> <Grid.Column width={3}>{t('fields.opmerking')}</Grid.Column>
                  <Grid.Column>
                  <Segment
                      color='red'
                    >
                      <i>{t('OTHERLANG', { lang : t(Object.keys(data.beschrijving)[0])})}</i>
                      <Divider />
                      {!!data.beschrijving[Object.keys(data.opmerking)[0]] && 
                        parse(he.decode(data.opmerking[Object.keys(data.opmerking)[0]]))
                      }
                    </Segment></Grid.Column>
                </Grid.Row>
            }

            {
              data.toon_toegang_platform_button &&  user === null &&
              <>
              <Grid.Row>
                <Grid.Column width={3}>
                  {t('toon_toegang_platform_button')}
                </Grid.Column>
                <Grid.Column>
                    {t('logEerstIn')}
                </Grid.Column>
                </Grid.Row>
                </>
            }
            
            {
              data.toon_toegang_platform_button &&  user !== null && !!!data.uses_activatiecodes &&
              <>
              <Grid.Row>
                <Grid.Column>
                  {data.uses_activatiecodes}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>

                <Grid.Column width={3}>
                  {t('toon_toegang_platform_button')}
                </Grid.Column>
                

              {/*
                <Grid.Column width={9}>

                  
                  <Input fluid placeholder={t('email_vraag_toegang_aan')} onChange={handleChange} value={email} disabled={requestingData} />
                </Grid.Column>
                <Grid.Column>
                  {
                    emailValid && 
                      <Button fluid positive onClick={() => sendAccessCode()} disabled={requestingData}>
                        {requestingData ? t('data_ophalen') :  t('vraag_toegang_aan')}
                      </Button>
                  }
                  {
                    !emailValid && 
                      <Button negative disabled>
                        {t('ongeldig_emailadres')}
                      </Button>
                  }
                </Grid.Column>
                */}
                <Grid.Column>
                  <Button 
                      disabled={!!loginData}
                      primary
                      inverted
                      fluid
                      onClick={() => getLoginData() }
                      //disabled={reportingError}
                      content= {t('toon_toegang_platform_button')}
                  >
                  </Button>
                </Grid.Column>
                </Grid.Row>
              
                {loginData !== null &&
                 <>
                  <Grid.Row>
                    <Grid.Column>
                    <Message
                      color='blue'
                      header={t('loginGegevens')}
                      content={t('loginGegevensMessage')}
                      attached
                    />
                    <Table celled>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>{t('gebruikersnaam')}</Table.Cell>
                          <Table.Cell>{loginData.gebruikersnaam}</Table.Cell>
                          <Table.Cell width={1}>
                            <Button 
                              color={!!!copied.gebruikersnaam ? 'blue' : 'green'}
                              inverted={!!!copied.gebruikersnaam}
                              circular 
                              icon="copy outline"
                              onClick={() => copyToClipBoard('gebruikersnaam',loginData.gebruikersnaam)}
                            />
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>{t('wachtwoord')}</Table.Cell>
                          <Table.Cell>{loginData.paswoord}</Table.Cell>
                          <Table.Cell width={1}>
                            <Button 
                              color={!!!copied.wachtwoord ? 'blue' : 'green'}
                              inverted={!!!copied.wachtwoord}
                              circular 
                              icon="copy outline"
                              onClick={() => copyToClipBoard('wachtwoord',loginData.paswoord)}
                            />
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                </Grid.Row> 
                
                </>}
              </>
            }
            { data.toon_toegang_platform_button === true  &&  user !== null && !!data.uses_activatiecodes &&
                <>
                <Grid.Row>
                  <Grid.Column width={3}>
                  {t('VERSTUUR_ACTIVATIECODE')}:
                  </Grid.Column>
                  <Grid.Column>
                     <Button 
                      disabled={!!requestingData}
                      fluid positive content={t('ACTIVATIE_BUTTON' , { titel : data.titel , user : email} )} 
                      onClick={() => {
                        sendAccessCode()
                      }}
                      />
                  </Grid.Column>
                </Grid.Row>
                </>
                }
                {
              user !== null && 
              <>
              <Divider />
              <Grid.Row textAlign='center'>
                <Grid.Column>
                  {parse(he.decode(t('problemText', { titel : data.titel })))}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
              <Grid.Column>
                <Form onSubmit={(e) => {e.preventDefault()}}>
                  <TextArea
                    color='red'
                    rows={4} 
                    placeholder={t('problemPlaceholder')}
                    onChange={handleTextarea}
                    disabled={reportingError}
                    value={problemMessage}
                  />
                </Form>
                {
                  problemMessage.length === 0 &&
                  <i>{t('PROBLEM_CHAR_MENTION',{num : probMinChar})}</i>
                }
                {
                  problemMessage.length > 0 && problemMessage.length < probMinChar &&
                  <i>{t('PROBLEM_CHAR_MIN_MENTION',{num : probMinChar - problemMessage.length})}</i>
                }
                {
                  problemMessage.length >= probMinChar && problemMessage.length <= probMaxChar &&
                  <i>{t('PROBLEM_CHAR_OK_MENTION',{num : probMaxChar - problemMessage.length})}</i>
                }
                {
                  problemMessage.length > probMaxChar &&
                  <i>{t('PROBLEM_CHAR_MAX_MENTION',{num : problemMessage.length - probMaxChar})}</i>
                }
                </Grid.Column>
                
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Button 
                      color='orange' 
                      inverted
                      fluid
                      onClick={() => reportProblem()}
                      disabled={reportingError || problemMessage.length < probMinChar || problemMessage.length > probMaxChar }
                  >
                    {!reportingError ? t("problem") : t("problemReporting")}
                  </Button>
                </Grid.Column>
              </Grid.Row>
              </>
            }

            </Grid>
            </Segment>
            }
            {
              !!data.error && 
              <Segment color='red'> 
              <Icon name='warning' color='red' />
                  {t(`${data.error}`)}
              </Segment>
            }
        </Suspense>
        
    </Container><ApplicationFooter version={pjson.version}/>
    </Container>
  );
}

export default Detail;